import script from "./AdminUserManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserManage.vue?vue&type=style&index=0&id=38232ae1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38232ae1"]])

export default __exports__